import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';

interface Props {
    message?: string;
}

function GiftMessage({ message }: Props) {
    if (!message?.trim()) return null;
    return <Box color={colors.textSecondary}>{message}</Box>;
}

const Box = styled(Text)`
    width: 100%;
    padding: var(--spacing-4);
    border-radius: 8px;
    background: ${colors.white};
    word-break: break-word;
`;

export default GiftMessage;
